import { translate } from '../../helpers/translate.helper';
import { useGroupContext } from '../../hooks/useGroupContext';
import { useFlags } from '../../launchDarkly/useFlags';
import { Box } from '../../ui/Box';
import {
    getGroupContextCompanySearch,
    getGroupContextCustomerCompanySearch,
    getGroupContextCustomerDemandSearch,
    getGroupContextCustomerGroupSearch,
} from '../../utils/getGroupContextSearchParams';
import { SidebarNavigationItem } from '../components/SidebarNavigationItem';
import { SidebarSectionHeading } from '../components/SidebarSectionHeading';

export const AdminSidebarNavigation = () => {
    const groupContext = useGroupContext();
    const flags = useFlags();

    const companySearch = getGroupContextCompanySearch(groupContext);
    const customerCompanySearch = getGroupContextCustomerCompanySearch(groupContext);
    const customerGroupSearch = getGroupContextCustomerGroupSearch(groupContext);
    const customerDemandSearch = getGroupContextCustomerDemandSearch(groupContext);

    return (
        <Box display="flex" flexDirection="column" gap={32}>
            <Box display="flex" flexDirection="column">
                <SidebarSectionHeading>{translate('sidebar.section.customer')}</SidebarSectionHeading>

                <SidebarNavigationItem to="/orders" search={companySearch}>
                    {translate('navigation.orders')}
                </SidebarNavigationItem>

                <SidebarNavigationItem to="/demand" search={customerDemandSearch}>
                    {translate('navigation.demandOverview')}
                </SidebarNavigationItem>

                {flags.demandDefinitionsEnabled ? (
                    <SidebarNavigationItem to="/demand-definitions">
                        {translate('navigation.demandDefinitions')}
                    </SidebarNavigationItem>
                ) : null}

                <SidebarNavigationItem to="/compare">{translate('navigation.compare')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/vessels" search={customerCompanySearch}>
                    {translate('navigation.vessels')}
                </SidebarNavigationItem>

                <SidebarNavigationItem to="/key-ports" search={customerGroupSearch}>
                    {translate('navigation.keyPorts')}
                </SidebarNavigationItem>

                <SidebarNavigationItem to="/contracts">{translate('navigation.contracts')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/agents" search={customerCompanySearch}>
                    {translate('navigation.agents')}
                </SidebarNavigationItem>
            </Box>

            <Box display="flex" flexDirection="column">
                <SidebarSectionHeading>{translate('sidebar.section.supplier')}</SidebarSectionHeading>

                <SidebarNavigationItem to="/offers" search={companySearch}>
                    {translate('navigation.offers')}
                </SidebarNavigationItem>

                <SidebarNavigationItem to="/requests-for-quotes" search={companySearch}>
                    {translate('navigation.requestsForQuotes')}
                </SidebarNavigationItem>
            </Box>

            <Box display="flex" flexDirection="column">
                <SidebarSectionHeading>{translate('sidebar.section.superAdmin')}</SidebarSectionHeading>

                <SidebarNavigationItem to="/customer-groups">{translate('navigation.customers')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/supplier-groups">{translate('navigation.suppliers')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/assignments" search={companySearch}>
                    {translate('navigation.assignments')}
                </SidebarNavigationItem>

                <SidebarNavigationItem to="/products">{translate('navigation.products')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/ports">{translate('navigation.ports')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/integrations">{translate('navigation.integrations')}</SidebarNavigationItem>

                <SidebarNavigationItem to="/statistics" search={companySearch}>
                    {translate('navigation.reporting')}
                </SidebarNavigationItem>
            </Box>
        </Box>
    );
};
